export default [
  {
    check: false,
    title: "화학설비와 그 부속설비 사용작업",
    subTitle: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
    typeLists: [
      {
        headerTitle: "작업계획서 내용",
        data: [
          { content: ["가", "밸브·콕 등의 조작(해당 화학설비에 원재료를 공급하거나 해당 화학설비에서 제품 등을 꺼내는 경우만 해당한다) "], isChecked: "" },
          { content: ["나", "냉각장치·가열장치·교반장치(攪拌裝置) 및 압축장치의 조작"], isChecked: "" },
          { content: ["다", "계측장치 및 제어장치의 감시 및 조정 "], isChecked: "" },
          { content: ["라", "안전밸브, 긴급차단장치, 그 밖의 방호장치 및 자동경보장치의 조정"], isChecked: "" },
          { content: ["마", "덮개판·플랜지(flange)·밸브·콕 등의 접합부에서 위험물 등의 누출 여부에 대한 점검 "], isChecked: "" },
          { content: ["바", "시료의 채취 "], isChecked: "" },
          { content: ["사", "화학설비에서는 그 운전이 일시적 또는 부분적으로 중단된 경우의 작업방법 또는 운전 재개 시의 작업방법"], isChecked: "" },
          { content: ["아", "이상 상태가 발생한 경우의 응급조치 "], isChecked: "" },
          { content: ["자", "위험물 누출 시의 조치 "], isChecked: "" },
          { content: ["차", "덮개판·플랜그 밖에 폭발·화재를 방지하기 위하여 필요한 조치지(flange)·밸브·콕 등의 접합부에서 위험물 등의 누출 여부에 대한 점검 "], isChecked: "" },
        ],
      },
    ],
  },
  {
    check: false,
    title: "전기작업",
    subTitle: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
    typeLists: [
      {
        headerTitle: "작업계획서 내용",
        data: [
          { content: ["가", "전기작업의 목적 및 내용"], isChecked: "" },
          { content: ["나", "전기작업 근로자의 자격 및 적정 인원"], isChecked: "" },
          { content: ["다", "작업 범위, 작업책임자 임명, 전격·아크 섬광·아크 폭발 등 전기 위험 요인 파악, 접근 한계거리, 활선접근 경보장치 휴대 등 작업시작 전에 필요한 사항"], isChecked: "" },
          { content: ["라", "제319조에 따른 전로 차단에 관한 작업계획 및 전원(電源) 재투입 절차 등 작업 상황에 필요한 안전 작업 요령"], isChecked: "" },
          { content: ["마", "절연용 보호구 및 방호구, 활선작업용 기구·장치 등의 준비·점검·착용·사용 등에 관한 사항"], isChecked: "" },
          { content: ["바", "점검·시운전을 위한 일시 운전, 작업 중단 등에 관한 사항"], isChecked: "" },
          { content: ["사", "교대 근무 시 근무 인계(引繼)에 관한 사항"], isChecked: "" },
          { content: ["아", "전기작업장소에 대한 관계 근로자가 아닌 사람의 출입금지에 관한 사항"], isChecked: "" },
          { content: ["자", "전기안전작업계획서를 해당 근로자에게 교육할 수 있는 방법과 작성된 전기안전작업계획서의 평가·관리계획"], isChecked: "" },
          { content: ["차", "전기 도면, 기기 세부 사항 등 작업과 관련되는 자료"], isChecked: "" },
        ],
      },
    ],
  },
  {
    check: false,
    title: "궤도와 그 밖의 관련설비의 보수·점검 작업",
    subTitle: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
    typeLists: [
      {
        headerTitle: "작업계획서 내용",
        data: [
          { content: ["가", "적절한 작업 인원 "], isChecked: "" },
          { content: ["나", "작업량"], isChecked: "" },
          { content: ["다", "작업순서"], isChecked: "" },
          { content: ["라", "작업방법 및 위험요인에 대한 안전조치방법 등"], isChecked: "" },
        ],
      },
    ],
  },
  {
    check: false,
    title: "입환작업",
    subTitle: "작업시작 전까지 확인사항 [별지 제3호의2서식] <신설 2018.09.28>",
    typeLists: [
      {
        headerTitle: "작업시작 전까지 확인사항",
        data: [
          { content: ["가", "철도운행안전협의 결과 작업원에게 통보"], isChecked: "" },
          { content: ["나", "작업구간(지장선로, 키로정 등) 확인"], isChecked: "" },
          { content: ["다", "전차선로 단전구간 확인"], isChecked: "" },
          { content: ["라", "작업원 이동 경로 작업자에게 통보"], isChecked: "" },
          { content: ["마", "열차감시원 배치계획 적정성 및 휴대품"], isChecked: "" },
          { content: ["바", "열차접근 시 대피 장소 작업원에게 통보"], isChecked: "" },
          { content: ["사", "운전취급자와 연락체계 확인"], isChecked: "" },
          { content: ["아", "전기철도안전관리자 배치"], isChecked: "" },
          { content: ["자", "건널목 임시관리원 배치"], isChecked: "" },
          { content: ["차", "합동 또는 병행작업 시 타분야와 협의"], isChecked: "" },
        ],
      },
      {
        headerTitle: "「작업시행승인」된 상태에서 작업시작 전까지 확인사항",
        data: [
          { content: ["가", "작업시행승인사항 작업원에게 통보"], isChecked: "" },
          { content: ["나", "열차감시원 정위치 확인(무선통화)"], isChecked: "" },
          { content: ["다", "열차감시원~작업현장간 경보체계 확인"], isChecked: "" },
          { content: ["라", "공사감독자 또는 작업책임자 작업원 인솔"], isChecked: "" },
          { content: ["마", "단락용 동선 설치(고속선 CPT 등을 체결)"], isChecked: "" },
          { content: ["바", "작업 인접선 안전조치"], isChecked: "" },
          { content: ["사", "작업 관련 표지류 설치"], isChecked: "" },
          { content: ["아", "서행 관련 임시신호기 등의 설치"], isChecked: "" },
          { content: ["자", "전차선로 단전 조치(접지걸이 포함)"], isChecked: "" },
          { content: ["차", "건설기계 작업지휘자 또는 유도자 배치"], isChecked: "" },
        ],
      },
    ],
  },
];
